import { isTypeLogo } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulLogo = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeLogo(entry)) {
    return null;
  }

  return (
    <div className='p-4 sm:w-1/4 md:w-1/6'>
      <a
        className='mx-auto flex items-center justify-center w-36 h-36 sm:w-40 sm:h-40 p-4'
        href={entry.fields.url}
      >
        {/* TODO: Is this used anywhere? */}
        {/*{entry.fields.title}*/}
        {entry.fields.image && (
          /* TODO: Reference or re-use the fadeable logos on the homepage */
          <img
            className='w-full max-w-36 max-h-36 grayscale opacity-60 transition-all duration-300 hover:grayscale-0 hover:opacity-100'
            src={entry.fields.image.fields.file?.url}
            alt={entry.fields.image.fields.title}
          />
        )}
      </a>
    </div>
  );
};

export default ContentfulLogo;
